import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyDurApOzpLnRd2NqMDRwBIFuA--gIGg8Ao",
  authDomain: "practicetalking-51175.firebaseapp.com",
  projectId: "practicetalking-51175",
  storageBucket: "practicetalking-51175.firebasestorage.app",
  messagingSenderId: "40471045787",
  appId: "1:40471045787:web:e0e25ff9af734ed69b883e",
  measurementId: "G-19WQR04Y38"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.addScope('profile');
googleProvider.addScope('email');
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

// Action Code Settings for email verification
export const actionCodeSettings = {
  url: process.env.NODE_ENV === 'production' 
    ? 'https://practicetalking.co/verify-email' 
    : 'http://localhost:3000/verify-email',
  handleCodeInApp: true,
};

export default app;